import React, { useState, lazy, Suspense } from "react";
import { useParams } from "react-router-dom";
import useWindowsSize from "@/Hooks/useWindowsSize";
import {
  HeaderFilterPlpMovil,
  HeaderPlpMovil,
  HeaderPlpWeb,
  NavMovil,
  GridViewProducts,
  DefaultPlp,
  DefaultPlpList,
  FilterWeb,
  ViewButtons,
  FilterMovil,
  CaruselButton,
} from "@/Components/Index";
import { LayoutPlp } from "@/Layout";
import { useProductsByCategory, useSubCategory } from "@/Service/Api/Index";
import { ReplaceCharacter } from "@/Utils/RemplaceCharacter";
const LazyListProduct = lazy(
  () => import("@/Components/Grid/GridList/GridList")
);
const LazyGridProduct = lazy(
  () => import("@/Components/Grid/GridSquare/GridSquare")
);

const LazyHeaderWeb = lazy(() => import("@/Components/Header/HeaderWeb"));
const LazyHeaderMovil = lazy(() => import("@/Components/Header/HeaderMovil"));
//css
const handdleStyle = {
  display: "flex",
  justifyContent: "flex-end",
  color: "#F1F4F8",
};

type paramsCategoria = {
  cteg?: string;
};

type paramsSubCategoria = {
  subcateg?: string;
};

const PlpArticles: React.FC = () => {
  //Categoria a mostrar
  const { cteg } = useParams<paramsCategoria>();
  const { subcateg } = useParams<paramsSubCategoria>();

  //================================================
  const { DatasProducts, DatasMarcas, isLoading } = useProductsByCategory(
    cteg!,
    subcateg!,
    "electronica"
  );

  //================================================
  const [Estado, setEstado] = useState<boolean>(true);

  //array filter marca
  const [SelectBrand, setSelectBrand] = useState<string[]>([]);

  //to order
  const [OrderToPrice, setOrderToPrice] = useState<number>(0);

  //activar o desactivar menu de marca
  const [filterActive, setFilterActive] = useState<boolean>(false);

  //screen de pantalla
  const { width } = useWindowsSize();
  //ruta principal anterior
  const previousStep = "/Electrónica"; ///Electrónica/Category
  //****** End Remplazar dato o simbolo o algo *********\\

  //** visualiza los datos is es modo grid o lista **\\
  const handleState = (viewState: boolean) => setEstado(viewState);
  //**************************************************\\

  //** guarda los datos por cuales vamos a filtrar **\\
  const handdleFilterData = (name: string, checked: boolean) => {
    //console.log(name, checked);
    if (checked) {
      setSelectBrand((prev) => [...prev, name]);
    } else {
      setSelectBrand((prev) => prev.filter((brands) => brands !== name));
    }
  };

  //*******  Ordenar por : ***********\\
  const handdleOrderTo = (event: number) => {
    setOrderToPrice(event);
  };

  //********* Filtrar datos ****************\\
  const handdleClickFilter = () => {
    DatasProducts.length > 0
      ? setFilterActive(!filterActive)
      : setFilterActive(false);
  };

  return (
    <Suspense>
      {width >= 1200 ? (
        <LazyHeaderWeb>
          <HeaderPlpWeb
            titles={ReplaceCharacter(cteg!)}
            toLink={previousStep}
            classNamesIcon={"icon-question-circle text-white"}
          />
        </LazyHeaderWeb>
      ) : (
        <LazyHeaderMovil isFilter={filterActive}>
          <NavMovil classNames={"align-items-center"}>
            <HeaderPlpMovil
              toLink={previousStep}
              title={ReplaceCharacter(cteg!)}
              toIcon={"/"}
            />
          </NavMovil>
          {
            //Vista de filtro
            DatasProducts ? (
              <HeaderFilterPlpMovil
                onClickFilter={handdleClickFilter}
                onChanges={handdleOrderTo}
                onClickState={handleState}
                isFilter={DatasProducts ? true : false}
                estado={Estado}
              />
            ) : (
              ""
            )
          }
        </LazyHeaderMovil>
      )}
      <LayoutPlp>
        <div className="ps-layout__left mt-3">
          <FilterWeb
            filterData={handdleFilterData}
            datosMarcas={Array.isArray(DatasMarcas) ? DatasMarcas : []}
            selectBrand={SelectBrand}
            onChanges={handdleOrderTo}
            isLoading={isLoading}
          />
        </div>
        <div className="ps-layout__right" style={{ margin: "0 auto" }}>
          <div className="ps-shopping ps-tab-root">
            <CaruselButton />
            {width >= 1200 ? (
              <div
                className={
                  width >= 1200
                    ? "ps-shopping__header mt-3"
                    : "ps-shopping__header"
                }
                style={handdleStyle}>
                <ViewButtons estado={Estado} clickState={handleState} />
              </div>
            ) : (
              ""
            )}
            {Estado ? (
              <GridViewProducts isEstadoActivo={Estado}>
                <div className="row">
                  {DatasProducts && !isLoading ? (
                    <LazyGridProduct
                      mData={DatasProducts}
                      priceFilter={SelectBrand}
                      orderType={OrderToPrice}
                      isLoading={isLoading}
                    />
                  ) : (
                    <DefaultPlp totales={6} />
                  )}
                </div>
              </GridViewProducts>
            ) : (
              <GridViewProducts isEstadoActivo={!Estado}>
                {DatasProducts ? (
                  <LazyListProduct
                    mData={DatasProducts}
                    priceFilter={SelectBrand}
                    orderType={OrderToPrice}
                    isLoading={isLoading}
                  />
                ) : (
                  <DefaultPlpList totales={3} />
                )}
              </GridViewProducts>
            )}
          </div>
        </div>
      </LayoutPlp>
      {filterActive ? (
        <FilterMovil
          isFilter={filterActive}
          filterData={handdleFilterData}
          toggleFilter={handdleClickFilter}
          datosMarcas={Array.isArray(DatasMarcas) ? DatasMarcas : []}
          selectBrand={SelectBrand}
        />
      ) : (
        ""
      )}
    </Suspense>
  );
};

export default PlpArticles;
